import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useHiringInstantPay() {
  return useCbhFlag(CbhFeatureFlag.HIRING_INSTANT_PAY, {
    defaultValue: {
      enabled: false,
    },
  });
}
